declare global {
	interface Window {
		dataLayer?: Record<string, unknown>[];
	}
}

export type GtmLeadEvent = "lead_whatsapp" | "lead_form";

export function pushGtmEvent(event: GtmLeadEvent) {
	if (typeof window === "undefined") return;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ event });
}

export function pushLeadWhatsapp() {
	pushGtmEvent("lead_whatsapp");
}

export function pushLeadForm() {
	pushGtmEvent("lead_form");
}
